import { useTranslation } from 'react-i18next';
import useAccountMenu from 'hooks/useAccountMenu';
import { LogOut } from 'lucide-react';
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

/**
 * The account dropdown items (role-gated destinations + sign out) for the desktop
 * sidebar menu (`CompanyNavMenu`). Must be rendered inside a `DropdownMenuContent`.
 * Shares its contents with the mobile account sheet via `useAccountMenu`.
 */
const AccountMenuItems = (): JSX.Element => {
  const { t } = useTranslation('common');
  const { items, signOut } = useAccountMenu();

  return (
    <>
      {items.map((item) => (
        <DropdownMenuItem key={item.key} onClick={item.onClick}>
          <item.icon />
          {item.label}
        </DropdownMenuItem>
      ))}

      <DropdownMenuSeparator />

      <DropdownMenuItem onClick={signOut}>
        <LogOut />
        {t('nav-sign-out', 'Log out')}
      </DropdownMenuItem>
    </>
  );
};

export default AccountMenuItems;
